import ActionTypes from '../actions/types'

const initialState = {
  // instance of AuthedUser (see /lib/AppAuth -> AuthedUser class)
  authedUser: undefined,
  isGlobalAdmin: false,
}

// --------------------------------------------------------------------------------
// State mutation functions:

/**
 * @param {*} state
 * @param {AuthedUser} authedUser
 * @param {boolean?} isGlobalAdmin
 * @return {*&{authedUser}}
 */
function setAuthedUser(state, authedUser, isGlobalAdmin) {
  return {...state, authedUser: authedUser, isGlobalAdmin: isGlobalAdmin}
}

// --------------------------------------------------------------------------------

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.AUTH_SET_AUTHED_USER:
      return setAuthedUser(state, action.payload, action.isGlobalAdmin)

    default:
      /* pass through */
      return state
  }
}
